import { VariantValueModelType } from '@teinor/erp/types/company/product/variant/variantValue'
import { VariantValueLangModelType } from '@teinor/erp/types/company/product/variant/variantValue/variantValueLang'
import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { MediumModalCreateEdit, ModalCreateEditMediumLoading } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { getLang } from '../../../../../../../../utils/globals'
import { useBasicData } from '../../../../../../../../utils/hooks/useBasicData'
import useLangData from '../../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs } from '../../../../../../../../utils/reducers/getters'
import { changeErrorMessage } from '../../../../../../../../utils/reducers/reduxDispatch'


interface ModalCEVariantValueProps extends ModalEditComponentProps { }

interface ModifiedVariantValueModelType extends VariantValueModelType {
    variantValueLangs: string
}
const ModalCEVariantValue: React.FC<ModalCEVariantValueProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const myLang = getLang()
    const params = useParams<{ VariantId?: string }>()
    const { basicData } = useBasicData({ url: '/api/app/product/productVariant/variantValue/getVariantValueInstance', params: { id: allRowData?.id }, doPetition: allRowData !== undefined })
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: basicData?.VariantValueLangs, fieldsToLang: ['name'], keyValue: 'LangId' })
    const { onError } = useModalCEVariantValueLogic()
    const fields: FormRender<VariantValueLangModelType & ModifiedVariantValueModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: myLang,
                    onChange: changeLang
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'ref_code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.ref_code
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: allRowData?.id
                },
                {
                    name: 'VariantGroupId',
                    component: 'InputHidden',
                    value: params?.VariantId
                },
                {
                    name: 'variantValueLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
            ]
        }
    ]
    if (allRowData && userPermissions) {
        return (
            <ModalCreateEditMediumLoading fields={fields} url={'/api/app/product/productVariant/variantValue/updateVariantValue'} translations={{ title: t('editVariantValue', 'Editar valor de variante') + ' - ' + allRowData?.['name'], button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} loading={data ? false : true} {...rest} onChangeError={onError} />
        )
    }
    return (
        <MediumModalCreateEdit fields={fields} url={'/api/app/product/productVariant/variantValue/createVariantValue'} translations={{
            title: t('createVariantValue', 'Crear valor de variante'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} onChangeError={onError} />
    )
}

const useModalCEVariantValueLogic = () => {
    const { t } = useTwinTranslation()

    const variantValueError = t('referenceCodeAlreadyExists', 'El código de referencia ya existe.')

    const onError: OnSubmit = useCallback(async (res, vals) => {
        const responseJSON = await res.json()
        if (responseJSON.errors[0].msg === 'This reference already exists') {
            changeErrorMessage(variantValueError)
        }
    }, [variantValueError])

    return { onError }
}

export default ModalCEVariantValue